module.exports = __webpack_public_path__ + "static/media/Vectordown.e3849c79.svg";